import compose from '../fp/compose';
import Cache from './Cache';
import jsonCache from './jsonCache';
import provideStorage from './provideStorage';
var SessionStorageCache = compose(jsonCache(), provideStorage(sessionStorage))(Cache);
export default SessionStorageCache;